export enum DocumentEditorNotificationType {
  SUCCESS = 'SUCCESS',
  NOT_SAVED = 'NOT_SAVED',
  WARNING = 'WARNING',
  MISSING_DATA = 'MISSING_DATA',
  INFO = 'INFO',
  ERROR = 'ERROR',
  FATAL = 'FATAL'
}
